module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "register-registConfirm"
    }
  }, [_c('section', {
    staticClass: "doctor-info"
  }, [_c('div', {
    staticClass: "head doc-header",
    style: ({
      backgroundImage: 'url(' +
        (_vm.registInfo.schedule.doctAvatar ?
          _vm.registInfo.schedule.doctAvatar :
          '../../../static/img/ico-doctor.png') +
        ')',
    })
  }, [(_vm.registInfo.schedule.typeId === '849772') ? _c('span', {
    staticClass: "type-tag tag-putong"
  }, [_vm._v(_vm._s(_vm.registInfo.schedule.typeName))]) : _vm._e(), _vm._v(" "), (_vm.registInfo.schedule.typeId === '643075') ? _c('span', {
    staticClass: "type-tag tag-zhuanjia"
  }, [_vm._v(_vm._s(_vm.registInfo.schedule.typeName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticStyle: {
      "padding-right": "0.5rem"
    }
  }, [_c('span', {
    staticClass: "f-large f-strong",
    staticStyle: {
      "margin-right": "0.25rem"
    }
  }, [_vm._v(_vm._s(_vm.registInfo.schedule.rankName))])]), _vm._v(" "), _c('p', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.registInfo.schedule.doctName))])])]), _vm._v(" "), _c('section', [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("预约科室")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.registInfo.schedule.deptName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("医院")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.hospitalName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("预约时间")]), _vm._v(" "), _c('dd', [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.registInfo.date.value)) + "  " + _vm._s(_vm.registInfo.date.weekDay) + "\n         " + _vm._s(_vm.registInfo.schedule.timeslot) + "\n      ")])]), _vm._v(" "), _c('dl', {
    staticClass: "field last"
  }, [_c('dt', [_vm._v("挂号金额")]), _vm._v(" "), _c('dd', {
    staticStyle: {
      "color": "#1d1d26"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#f24141"
    }
  }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.registInfo.schedule.fee)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "padding": "0.3rem"
    }
  }, [_c('span', [_vm._v("选择就诊凭证 ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddVoucherBtn),
      expression: "showAddVoucherBtn"
    }],
    staticClass: "btn-ugly",
    on: {
      "click": _vm.addVoucher
    }
  }, [_vm._v("\n      +添加就诊凭证\n    ")])]), _vm._v(" "), _c('scroll', {
    staticClass: "to-bottom-btn",
    staticStyle: {
      "top": "9rem",
      "margin-top": "0.5rem",
      "background": "#fff"
    },
    on: {
      "refresh": _vm.loadVouchers
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddVoucherArea),
      expression: "showAddVoucherArea"
    }],
    staticClass: "flex-row flex-align-center add-voucher-area",
    on: {
      "click": _vm.addVoucher
    }
  }, [_c('div', {
    staticClass: "add-voucher-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-1 flex-width"
  }, [_vm._v("\n        暂无就诊凭证，请"), _c('span', {
    staticClass: "f-strong"
  }, [_vm._v("先绑定就诊凭证")])])]), _vm._v(" "), _vm._l((_vm.vouchers), function(voucher, index) {
    return _c('voucher-item-small', {
      key: index,
      class: _vm.selectedIndex == index ? 'selected' : 'disabled',
      attrs: {
        "voucher": voucher,
        "index": index
      },
      on: {
        "selected": _vm.selectVoucher
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPrompt),
      expression: "showPrompt"
    }],
    staticClass: "register-des"
  }, [_c('h5', {
    staticClass: "reminder"
  }, [_vm._v("挂号须知")]), _vm._v(" "), _c('p', [_vm._v("1.微信挂号不能享受医保6元诊疗补助。")]), _vm._v(" "), _c('p', [_vm._v("\n        2.预约挂号时间为参考时间，具体就诊时间以实际时间为准；取消预约至少提前一天，当天不可取消且无法退款。\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        3.预约挂号为实名制绑定电子健康卡使用，就诊时请携带电子健康卡到医院就诊，若未办理电子健康卡请及时办理。\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPrompt),
      expression: "!showPrompt"
    }],
    staticClass: "register-des"
  }, [_c('h5', {
    staticClass: "reminder"
  }, [_vm._v("挂号须知")]), _vm._v(" "), _c('p', [_vm._v("1.取消预约至少提前一天，当天不可取消且无法退款。")]), _vm._v(" "), _c('p', [_vm._v("\n        2.预约挂号为实名制绑定电子健康卡使用，就诊时请携带电子健康卡到医院就诊，若未办理电子健康卡请及时办理。\n      ")])])], 2), _vm._v(" "), _c('message-confirm', {
    attrs: {
      "title": "请勿重复预约",
      "text": "请前往我的挂号进行缴费或取消预约",
      "action": "前往我的挂号"
    },
    on: {
      "on-action": _vm.gotoMyRegister
    },
    model: {
      value: (_vm.showMessageConfirm),
      callback: function($$v) {
        _vm.showMessageConfirm = $$v
      },
      expression: "showMessageConfirm"
    }
  }), _vm._v(" "), _c('payConfirm', {
    model: {
      value: (_vm.showPayConfirm),
      callback: function($$v) {
        _vm.showPayConfirm = $$v
      },
      expression: "showPayConfirm"
    }
  }), _vm._v(" "), _c('footer', [_c('button', {
    staticClass: "btn-complete",
    staticStyle: {
      "border-radius": "0"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sumbitRegist
    }
  }, [_vm._v("\n      确认挂号\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c53eb74","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/register/RegistConfirm.vue
// module id = 797
// module chunks = 0